type BathroomRepairLastProject = {
  title: string;
  date: string;
  images: string[];
  price: number;
  link: string;
  linkTitle: string;
};

export const BATHROOM_REPAIR_LAST_PROJECTS_DATA: BathroomRepairLastProject[] = [
  {
    title: 'header.title',
    date: 'last-projects.project-first.date',
    images: [
      `/projects/first-bathroom-1.jpg/first-bathroom-1.jpg`,
      `/projects/first-bathroom-2.jpg/first-bathroom-2.jpg`,
      `/projects/first-bathroom-3.jpg/first-bathroom-3.jpg`,
    ],
    price: 171225,
    link:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/bathroom-repair/Smeta_proekta_vannoy_komnaty.pdf',
    linkTitle: 'last-projects.project-first.button-name',
  },
  {
    title: 'last-projects.project-second.title',
    date: 'last-projects.project-second.date',
    images: [
      `/projects/toilet-1.jpg/toilet-1.jpg`,
      `/projects/toilet-2.jpg/toilet-2.jpg`,
      `/projects/toilet-3.jpg/toilet-3.jpg`,
    ],
    price: 44205,
    link:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/bathroom-repair/Smeta_proekta_tualeta.pdf',
    linkTitle: 'last-projects.project-second.button-name',
  },
  {
    title: 'last-projects.project-third.title',
    date: 'last-projects.project-third.date',
    images: [
      `/projects/second-bathroom-1.jpg/second-bathroom-1.jpg`,
      `/projects/second-bathroom-2.jpg/second-bathroom-2.jpg`,
      `/projects/second-bathroom-3.jpg/second-bathroom-3.jpg`,
    ],
    price: 143844,
    link:
      'https://storage.yandexcloud.net/lemanapro-ru-landings-docs/bathroom-repair/Smeta_proekta_sovmeshchyonnogo_sanuzla.pdf',
    linkTitle: 'last-projects.project-third.button-name',
  },
];
